module.exports = __webpack_public_path__ + "static/media/luminatouch-logo.8fd8a850.jpg";